import { frontendURL } from '../../../../helper/URLHelper';
import KanbanIndex from './Index.vue';
import ManageKanban from './Manage.vue';
import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/kanban'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_kanban_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_kanban_list',
          component: KanbanIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/kanban'),
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'SIDEBAR.KANBAN',
          icon: 'i-lucide-kanban-square',
          showBackButton: true,
          backUrl: { name: 'settings_kanban_list' },
        };
      },
      children: [
        {
          path: ':kanbanId/manage',
          name: 'settings_kanban_manage',
          component: ManageKanban,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
